"use client"
import { useState, useEffect } from 'react';

const BulletinAlert = ({ header, body, state, callback }) => {
     const [bulletinOpen, setBulletinOpen] = useState(false)
  // console.log('alert state', state)
  // console.log('message', message)



  useEffect(() => {
     setTimeout(() => {
          setBulletinOpen(true)
     }, 2000);
    // Only set the timeout if there's something to close (i.e., success or error message is visible)
    
     //  let timer = setTimeout(() => { handleClose(); }, 15000);
     //  // Cleanup timeout on component unmount or if state changes before the timeout completes
     //  return () => clearTimeout(timer);
    
    // This effect depends on state.success and state.error, so include them in the dependency array
  }, []); // Add state.success and state.error to the dependency array
  

  

  const handleClose = () => {
    // callback({action: "alertControl", success: false, error:false})
//     state.setSuccess(false);
//     state.setError(false);
     setBulletinOpen(false)
  };

  return (
    <>

     <div className="ml-14 flex justify-center items-center">
     
     <div
       className={`fixed text-sm rounded-l-xl shadow-xl z-40 bottom-3 right-0 w-3/5 md:w-2/4 lg:w-1/4 p-4 bg-gray-50 dark:bg-gray-900 border-gray-400 dark:border-gray-700 text-black dark:text-white transition-transform duration-300 transform ${bulletinOpen ? 'translate-y-0' : 'translate-y-96'} `}
     >



       <div className="flex justify-between items-center">
       <div className=''>
          <span className='font-bold'>{header}</span>
          <br/>
       {body}
       </div>


      <button onClick={()=>{handleClose()}} type="button" className={`h-8 w-14 transition duration-300 ease-in-out ml-auto -mx-1.5 -my-1.5 bg-gray-100 hover:bg-gray-200 text-gray-500 dark:text-gray-400 focus:ring-gray-400 rounded-lg focus:ring-2 p-1.5 inline-flex items-center justify-center dark:bg-gray-800 dark:hover:bg-gray-700`} data-dismiss-target="#alert-2" aria-label="Close">
          <span className="sr-only">Close</span>
          <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
        </button>


       </div>
     </div>
   </div>
</>
  );
};

export default BulletinAlert;